import React from "react";
import * as ReactDOMClient from "react-dom/client";
import App from "./App";
import { MaterialUIControllerProvider } from "./context";
import { BrowserRouter } from "react-router-dom";
// import { store } from './pages/generalMaster/category/reducers/store';
import { Provider } from "react-redux";
import { store } from "./Store";
import { SnackbarProvider } from "./context/popup";

const container = document.getElementById("root");
const root = ReactDOMClient.createRoot(container);

root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <SnackbarProvider>
        <Provider store={store}>
          <App />
        </Provider>
      </SnackbarProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);
